import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import {
  DefineRepositoryParams,
  RepositoryAbstract
} from './repository.abstract';
import { ElementOrder } from '../../core/declarations/tenant-setting.interface';

export type ElementOrderArea = keyof ElementOrder;

type ElementOrderRepositoryParams = DefineRepositoryParams<ElementOrder>;

@Injectable({ providedIn: 'root' })
export class ElementOrderRepository extends RepositoryAbstract<ElementOrderRepositoryParams> {
  constructor(injector: Injector) {
    super('element_order', injector);
  }

  /** Admin-only: persist a new key order for one area on the current tenant. */
  updateOrder(
    area: ElementOrderArea,
    order: Array<string | number>
  ): Observable<void> {
    return this.http.patch<void>(this.RESOURCE_URL, { area, order });
  }
}
